import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import {
    Banner,
    YourABAPractice,
    AccessKey,
    CompleteABACare,
    DataCollection,
    PowerfulFeatures,
    WhyTherapy,
    TrustedProfessionals,
   RevenueManagement,
} from './core';
import { ReadyTransform } from '../../common';
import { authActions } from 'store';

export const HomeFragment = () => {
    const dispatch = useDispatch();
    const params = useParams();

    useEffect(() => {
        if (params?.id) {
            let deviceId = localStorage.getItem('deviceId');
            if (!deviceId) {
                deviceId = uuidv4();
                localStorage.setItem('deviceId', deviceId);
            }

            dispatch(
                authActions.saveQrScanning({
                    qrId: params.id,
                    deviceId,
                })
            );
        }
    }, [params?.id, dispatch]);

    return (
        <div className="home-fragment">
            <Banner />
            <YourABAPractice />
            <CompleteABACare />
            <DataCollection />
            <RevenueManagement />
            <PowerfulFeatures />
            <AccessKey />
            <WhyTherapy />
            <TrustedProfessionals />
            <ReadyTransform />
        </div>
    );
};
